export default [
    {
        title: 'مدیریت پروازها',
        icon: 'bx bx-chalkboard',
        children: [
            {
                title: 'پروازها',
                route: { name: 'flight' },
                resource: 'FlightManager',
                action: 'show',
            },
            {
                title: 'ایرلاین‌ها',
                route: { name: 'airline' },
                resource: 'AirlineManager',
                action: 'show',
            },
            {
                title: 'هواپیماها',
                route: { name: 'airplane' },
                resource: 'AirplaneManager',
                action: 'show',
            },
            {
                title: 'فرودگاه‌ها',
                route: { name: 'airport' },
                resource: 'AirportManager',
                action: 'show',
            },
            {
                title: 'شهرها',
                route: { name: 'city' },
                resource: 'CityManager',
                action: 'show',
            },
            {
                title: 'کشورها',
                route: { name: 'country' },
                resource: 'CountryManager',
                action: 'show',
            },
            {
                title: 'مسیرها',
                route: { name: 'route' },
                resource: 'RouteManager',
                action: 'show',
            },
        ],
    },
]
